import { isArray, isEmpty } from 'underscore';
import I18n from 'I18n';
import { PropertyType } from 'FormsUI/lib/Property';
import { DependentFieldOperator } from 'FormsUI/constants/DependentFields';
import { DependentFieldFilterKeys } from 'forms-utils-lib/dependent-fields/constants';
import { DependentFieldValidationType } from 'FormsUI/constants/DependentFields';
import { FieldTypes } from 'ui-forms-components/constants/FieldTypeMapping';
import { getFormatTextFromMetaData } from 'FormsUI/utils/DateUtils';
const isNumber = value => {
  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
};
function getKey(formFieldType, dependentFieldFilter) {
  if (dependentFieldFilter.operator === DependentFieldOperator.IS_NOT_EMPTY) {
    return null;
  }
  switch (formFieldType) {
    case PropertyType.ENUMERATION:
      return DependentFieldFilterKeys.STRING_VALUES;
    case PropertyType.DATE:
    case PropertyType.DATE_TIME:
      switch (dependentFieldFilter.operator) {
        case DependentFieldOperator.BETWEEN:
        case DependentFieldOperator.NOT_BETWEEN:
        case DependentFieldOperator.WITHIN_TIME:
        case DependentFieldOperator.WITHIN_TIME_REVERSE:
          return DependentFieldFilterKeys.STRING_VALUES;
        default:
          return DependentFieldFilterKeys.STRING_VALUE;
      }
    case PropertyType.NUMBER:
      switch (dependentFieldFilter.operator) {
        case DependentFieldOperator.BETWEEN:
        case DependentFieldOperator.NOT_BETWEEN:
          return DependentFieldFilterKeys.NUMBER_VALUES;
        default:
          return DependentFieldFilterKeys.NUMBER_VALUE;
      }
    case PropertyType.STRING:
      return DependentFieldFilterKeys.STRING_VALUE;
    default:
      return null;
  }
}
const getDateValue = (date, field) => I18n.moment(new Date(date)).format(getFormatTextFromMetaData(field));
export function getPreviewValue(formField, dependentFieldFilter) {
  const key = getKey(formField.type, dependentFieldFilter);
  let value = null;
  if (key) {
    value = dependentFieldFilter[key];
  }
  if (isArray(value)) {
    switch (dependentFieldFilter.operator) {
      case DependentFieldOperator.BETWEEN:
      case DependentFieldOperator.NOT_BETWEEN:
        if (formField.type === FieldTypes.DATE) {
          value = value.map(singleValue => getDateValue(singleValue, formField));
        }
        return value.join(` ${I18n.text('and')} `);
      case DependentFieldOperator.WITHIN_TIME:
      case DependentFieldOperator.WITHIN_TIME_REVERSE:
        if (value[1] === 'd') {
          return `${value[0]} ${I18n.text('editor.form.config.dependentFields.daysAgo')}`;
        } else if (value[1] === 'w') {
          return `${value[0]} ${I18n.text('editor.form.config.dependentFields.weeksAgo')}`;
        }
        break;
      default:
        return value.join(', ');
    }
  }
  if (formField.type === FieldTypes.DATE && value) {
    value = getDateValue(value, formField);
  }
  return value != null // account for 0 value
  ? value.toString() : '';
}
export function validateDependentField(formFieldType, dependentField) {
  const {
    filters,
    dependentFormField
  } = dependentField;
  const errors = {};
  if (isEmpty(dependentFormField) || isEmpty(dependentFormField.name)) {
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    errors[DependentFieldValidationType.FIELD_REQUIRED] = true;
  }
  if (isEmpty(filters[0].operator)) {
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    errors[DependentFieldValidationType.OPERATOR_REQUIRED] = true;
  }
  const keyContainingValue = getKey(formFieldType, filters[0]);
  if (filters[0].operator !== DependentFieldOperator.IS_NOT_EMPTY // operator with no value to match
  ) {
    let value = null;
    if (keyContainingValue) {
      value = filters[0][keyContainingValue];
    }
    const operator = filters[0].operator;
    if (isArray(value)) {
      if (operator === DependentFieldOperator.BETWEEN || operator === DependentFieldOperator.NOT_BETWEEN || operator === DependentFieldOperator.WITHIN_TIME || operator === DependentFieldOperator.WITHIN_TIME_REVERSE) {
        if (value.length !== 2) {
          // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
          errors[DependentFieldValidationType.VALUE_REQUIRED] = true;
        } else if (!isNumber(value[0]) && isEmpty(value[0]) || !isNumber(value[1]) && isEmpty(value[1])) {
          // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
          errors[DependentFieldValidationType.VALUE_REQUIRED] = true;
        }
      } else if (isEmpty(value)) {
        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        errors[DependentFieldValidationType.VALUE_REQUIRED] = true;
      }
    } else if (!isNumber(value) && isEmpty(value)) {
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      errors[DependentFieldValidationType.VALUE_REQUIRED] = true;
    }
  }
  return errors;
}